import { render, staticRenderFns } from "./UIMoney.vue?vue&type=template&id=57143084&"
import script from "./UIMoney.vue?vue&type=script&lang=js&"
export * from "./UIMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports